import AlbumPage from './AlbumPage'

export default [
	{
		path: '/album/:id',
		component: AlbumPage
	}
]


// WEBPACK FOOTER //
// ./src/pages/album/albumRoutes.js